export const GET_ROLES_REQUEST = 'GET_ROLES_REQUEST';
export const GET_ROLES_SUCCESS = 'GET_ROLES_SUCCESS';
export const GET_ROLES_FAILURE = 'GET_ROLES_FAILURE';

export const GET_STATUS_REQUEST = 'GET_STATUS_REQUEST';
export const GET_STATUS_SUCCESS = 'GET_STATUS_SUCCESS';
export const GET_STATUS_FAILURE = 'GET_STATUS_FAILURE';

export const GET_DOCUMENT_MODULES_REQUEST = 'GET_DOCUMENT_MODULES_REQUEST';
export const GET_DOCUMENT_MODULES_SUCCESS = 'GET_DOCUMENT_MODULES_SUCCESS';
export const GET_DOCUMENT_MODULES_FAILURE = 'GET_DOCUMENT_MODULES_FAILURE';

export const GET_DOCUMENT_TYPES_REQUEST = 'GET_DOCUMENT_TYPES_REQUEST';
export const GET_DOCUMENT_TYPES_SUCCESS = 'GET_DOCUMENT_TYPES_SUCCESS';
export const GET_DOCUMENT_TYPES_FAILURE = 'GET_DOCUMENT_TYPES_FAILURE';

export const GET_DOCUMENT_TYPES_WITH_CONFIGURATION_REQUEST = 'GET_DOCUMENT_TYPES_WITH_CONFIGURATION_REQUEST';
export const GET_DOCUMENT_TYPES_WITH_CONFIGURATION_SUCCESS = 'GET_DOCUMENT_TYPES_WITH_CONFIGURATION_SUCCESS';
export const GET_DOCUMENT_TYPES_WITH_CONFIGURATION_FAILURE = 'GET_DOCUMENT_TYPES_WITH_CONFIGURATION_FAILURE';

export const GET_STORAGE_TYPES_REQUEST = 'GET_STORAGE_TYPES_REQUEST';
export const GET_STORAGE_TYPES_SUCCESS = 'GET_STORAGE_TYPES_SUCCESS';
export const GET_STORAGE_TYPES_FAILURE = 'GET_STORAGE_TYPES_FAILURE';

export const GET_COMMUNICATION_TYPES_REQUEST = 'GET_COMMUNICATION_TYPES_REQUEST';
export const GET_COMMUNICATION_TYPES_SUCCESS = 'GET_COMMUNICATION_TYPES_SUCCESS';
export const GET_COMMUNICATION_TYPES_FAILURE = 'GET_COMMUNICATION_TYPES_FAILURE';

export const GET_PRIORITY_TYPES_REQUEST = 'GET_PRIORITY_TYPES_REQUEST';
export const GET_PRIORITY_TYPES_SUCCESS = 'GET_PRIORITY_TYPES_SUCCESS';
export const GET_PRIORITY_TYPES_FAILURE = 'GET_PRIORITY_TYPES_FAILURE';

export const GET_RECIPIENT_GROUP_REQUEST = 'GET_RECIPIENT_GROUP_REQUEST';
export const GET_RECIPIENT_GROUP_SUCCESS = 'GET_RECIPIENT_GROUP_SUCCESS';
export const GET_RECIPIENT_GROUP_FAILURE = 'GET_RECIPIENT_GROUP_FAILURE';

export const GET_USERS_FOR_DD_REQUEST = 'GET_USERS_FOR_DD_REQUEST';
export const GET_USERS_FOR_DD_SUCCESS = 'GET_USERS_FOR_DD_SUCCESS';
export const GET_USERS_FOR_DD_FAILURE = 'GET_USERS_FOR_DD_FAILURE';

export const GET_INVESTORS_FOR_DD_REQUEST = 'GET_INVESTORS_FOR_DD_REQUEST';
export const GET_INVESTORS_FOR_DD_SUCCESS = 'GET_INVESTORS_FOR_DD_SUCCESS';
export const GET_INVESTORS_FOR_DD_FAILURE = 'GET_INVESTORS_FOR_DD_FAILURE';

export const UPDATE_COMMON_REDUCER = 'UPDATE_COMMON_REDUCER';

export const GET_EQUITY_TYPE_CLASS_REQUEST = 'GET_EQUITY_TYPE_CLASS_REQUEST';
export const GET_EQUITY_TYPE_CLASS_SUCCESS = 'GET_EQUITY_TYPE_CLASS_SUCCESS';
export const GET_EQUITY_TYPE_CLASS_FAILURE = 'GET_EQUITY_TYPE_CLASS_FAILURE';

export const DOCUMENT_DOWNLOAD_REQUEST = 'DOCUMENT_DOWNLOAD_REQUEST';
export const DOCUMENT_DOWNLOAD_SUCCESS = 'DOCUMENT_DOWNLOAD_SUCCESS';
export const DOCUMENT_DOWNLOAD_FAILURE = 'DOCUMENT_DOWNLOAD_FAILURE';

export const GET_HOLDCO_USER_REQUEST = 'GET_HOLDCO_USER_REQUEST';
export const GET_HOLDCO_USER_SUCCESS = 'GET_HOLDCO_USER_SUCCESS';
export const GET_HOLDCO_USER_FAILURE = 'GET_HOLDCO_USER_FAILURE';

export const GET_STATUS_BY_TYPE_REQUEST = 'GET_STATUS_BY_TYPE_REQUEST';
export const GET_STATUS_BY_TYPE_SUCCESS = 'GET_STATUS_BY_TYPE_SUCCESS';
export const GET_STATUS_BY_TYPE_FAILURE = 'GET_STATUS_BY_TYPE_FAILURE';

export const GET_USER_DETAILS_REQUEST = 'GET_USER_DETAILS_REQUEST';
export const GET_USER_DETAILS_SUCCESS = 'GET_USER_DETAILS_SUCCESS';
export const GET_USER_DETAILS_FAILURE = 'GET_USER_DETAILS_FAILURE';

export const SAVE_CONTACT_US_REQUEST = 'SAVE_CONTACT_US_REQUEST';
export const SAVE_CONTACT_US_SUCCESS = 'SAVE_CONTACT_US_SUCCESS';
export const SAVE_CONTACT_US_FAILURE = 'SAVE_CONTACT_US_FAILURE';
// actionType.js
export const RESET_CONTACT_US_STATUS = 'RESET_CONTACT_US_STATUS';

export const SAVE_DATA_UPLOAD_CENTER_REQUEST = 'SAVE_DATA_UPLOAD_CENTER_REQUEST';
export const SAVE_DATA_UPLOAD_CENTER_SUCCESS = 'SAVE_DATA_UPLOAD_CENTER_SUCCESS';
export const SAVE_DATA_UPLOAD_CENTER_FAILURE = 'SAVE_DATA_UPLOAD_CENTER_FAILURE';

export const DELETE_NOTIFICATION_FILE_REQUEST = 'DELETE_NOTIFICATION_FILE_REQUEST';
export const DELETE_NOTIFICATION_FILE_SUCCESS = 'DELETE_NOTIFICATION_FILE_SUCCESS';
export const DELETE_NOTIFICATION_FILE_FAILURE = 'DELETE_NOTIFICATION_FILE_FAILURE';

export const GET_CATEGORY_FOR_DROPDOWN_REQUEST = 'GET_CATEGORY_FOR_DROPDOWN_REQUEST';
export const GET_CATEGORY_FOR_DROPDOWN_SUCCESS = 'GET_CATEGORY_FOR_DROPDOWN_SUCCESS';
export const GET_CATEGORY_FOR_DROPDOWN_FAILURE = 'GET_CATEGORY_FOR_DROPDOWN_FAILURE';

export const GET_CLASSIFICATION_REQUEST = 'GET_CLASSIFICATION_REQUEST';
export const GET_CLASSIFICATION_SUCCESS = 'GET_CLASSIFICATION_SUCCESS';
export const GET_CLASSIFICATION_FAILURE = 'GET_CLASSIFICATION_FAILURE';

export const SET_AUTHORIZED_USER = 'SET_AUTHORIZED_USER';
